module.exports = __webpack_public_path__ + "static/redmine-0104e015418ba5fd3ca983f8069b65ae.svg";